import React from 'react';
import moment from 'moment';

const Footer = () => {
  const currentYear = moment(new Date()).format('YYYY');

  return (
    <footer className='main-footer'>
      <p>{`© ${currentYear} National Marine Manufacturers Association`}</p>
    </footer>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/app/Routing/Footer.jsx